var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWhiteDownArrow = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 9,
  viewBox: "0 0 14 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.55356 8.19254L0.303558 1.94253C0.245489 1.88447 0.199427 1.81553 0.168 1.73966C0.136574 1.66379 0.120398 1.58247 0.120398 1.50035C0.120398 1.41823 0.136574 1.33691 0.168 1.26104C0.199427 1.18517 0.245489 1.11623 0.303558 1.05816C0.361627 1.00009 0.430565 0.954028 0.506435 0.922601C0.582306 0.891174 0.663624 0.874999 0.745746 0.874999C0.827868 0.874999 0.909185 0.891174 0.985056 0.922601C1.06093 0.954028 1.12986 1.00009 1.18793 1.05816L6.99575 6.86675L12.8036 1.05816C12.9208 0.940884 13.0799 0.875 13.2457 0.875C13.4116 0.875 13.5707 0.940884 13.6879 1.05816C13.8052 1.17544 13.8711 1.3345 13.8711 1.50035C13.8711 1.6662 13.8052 1.82526 13.6879 1.94254L7.43793 8.19254C7.37989 8.25065 7.31096 8.29675 7.23508 8.3282C7.15921 8.35965 7.07788 8.37584 6.99575 8.37584C6.91361 8.37584 6.83228 8.35965 6.75641 8.3282C6.68053 8.29674 6.6116 8.25065 6.55356 8.19254Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWhiteDownArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/white_down_arrow.d029fac16842c31a72e4c2a2e9e8bcd2.svg";